export default "__VITE_ASSET__BTRNjM5v__"